export default "__VITE_ASSET__BiQADqmw__"